$(document).ready(function() {
	// Reposition side tab based on widths
	var newright = -1000;
	newright = -1*($('#side-hover').width());
	
	$('#side-hover').css('right', newright);
	
	
	/*$('#side-hover').hover(function() {
		$(this).stop(true, false).animate({'right': 0}, 750, 'easeOutExpo');
	}, function() {
		$(this).stop(true, false).animate({'right': newright}, 1000, 'easeInExpo');
	});*/

});